import React from 'react'
import { Head, Link } from '@inertiajs/inertia-react'
import Layout from '../../Shared/Layout/LayoutAdmin'
import { Table } from 'react-bootstrap'
import Breadcrumbs from '../../Shared/Components/Breadcrumbs'
import { formatMoney } from '../../utils/formatters';

const Cancelled = ({ metric, totalPolicies }) => {
    const monthNames = [
        'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
        'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ];

    const cancelledPolicies = metric.commission_metrics_policies.filter(
        policy => policy.status === 'cancelled'
    );

    return (
        <>
            <Head title="Pólizas Canceladas" />

            <div className="mb-7 mt-7 d-flex justify-content-between align-items-center">
                <Breadcrumbs currentPath={`/admin/commission-metrics/${metric.id}/cancelled`} />
                <Link
                    href={route('commission-metrics.adviser', metric.adviser_id)}
                    className="btn btn-light"
                >
                    <i className="fas fa-arrow-left me-2"></i>
                    Regresar a Comisiones del Asesor
                </Link>
            </div>

            <div className="card card-flush h-md-100">
                <div className="card-header">
                    <h3 className="card-title">
                        Pólizas Canceladas - {monthNames[metric.month - 1]} {metric.year}
                    </h3>
                    <h3 className="card-title">Asesor: {metric.adviser?.user?.name} {metric.adviser?.lastname_ap} {metric.adviser?.lastname_am}</h3>
                </div>
                <div className="card-body">
                    <div className="row mb-4">
                        <div className="col-md-4">
                            <strong>Total Pólizas Canceladas:</strong> {cancelledPolicies.length}
                        </div>
                    </div>

                    <Table className="table table-row-dashed align-middle gs-0 gy-3 my-0">
                        <thead>
                            <tr className="fs-7 fw-bold text-gray-400 border-bottom-0">
                                <th className="p-0 pb-3 min-w-175px text-start">FOLIO</th>
                                <th className="p-0 pb-3 min-w-175px text-start">PÓLIZA</th>
                                <th className="text-start">FOLIO INBURSA</th>
                                <th className="text-start"># PAGO</th>
                                <th className="text-start">% COMISIÓN</th>
                                <th className="text-start">ORIGEN %</th>
                                <th className="text-start">MONTO INBURSA</th>
                                <th className="text-start">MONTO COMISIÓN</th>
                                <th className="p-0 pb-3 min-w-175px text-start">NOTA CANCELACIÓN</th>
                            </tr>
                        </thead>
                        <tbody>
                            {cancelledPolicies.map(policy => (
                                <tr key={policy.id}>
                                    <td>{policy.folio}</td>
                                    <td>{policy.policy_relation?.policy}</td>
                                    <td>{policy.commission_inbursa?.folio}</td>
                                    <td>{policy.payment_number ?? 0}</td>
                                    <td>{Number(policy.commission_rate || 0).toFixed(2)}%</td>
                                    <td>{policy.commission_rate_source}</td>
                                    <td>{formatMoney(policy.commission_inbursa_amount)}</td>
                                    <td>{formatMoney(policy.commission_amount)}</td>
                                    <td>{policy.note_cancelled || 'Sin nota'}</td>
                                </tr>
                            ))}
                            {cancelledPolicies.length === 0 && (
                                <tr>
                                    <td colSpan="5" className="text-center">
                                        No hay pólizas canceladas
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </div>
            </div>
        </>
    )
}

Cancelled.layout = page => <Layout children={page} title="Comisiones de Pólizas Canceladas" />

export default Cancelled
